import { APP_VERSION } from '@beatgig/constants/app-version'

const VERSION = APP_VERSION
export default VERSION
